export default __webpack_public_path__ + "static/media/add-white.f474c859.svg";